module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isForceLogin) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "indeterminate"
  })]) : _c('div', {
    staticClass: "container a3d splash"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "col s6 right-align"
  }, [_c('a', {
    staticClass: "btn a3d inv",
    on: {
      "click": function($event) {
        return _vm.auth.login(true)
      }
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('div', {
    staticClass: "col s6 left-align"
  }, [_c('a', {
    staticClass: "btn a3d",
    on: {
      "click": function($event) {
        return _vm.auth.login(false)
      }
    }
  }, [_vm._v("Log in")])]), _vm._v(" "), (_vm.$route.path == '/logout') ? _c('p', {
    staticClass: "col s12 align-center"
  }, [_vm._v("You have logged out successfully")]) : _vm._e()]), _vm._v(" "), (!_vm.isPassWasChanged) ? _c('div', {
    staticClass: "reset-password-message"
  }, [_vm._v("\n    As Siemens security has now been added to this software as a service,\n    you must change your password before logging in if you have not changed your password since June 5, 2020.\n    Please follow next steps:\n    "), _vm._m(1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 center"
  }, [_c('img', {
    staticClass: "responsive-img center-align",
    attrs: {
      "src": "/static/img/siemens_logo.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Click \"Log in\".")]), _vm._v(" "), _c('li', [_vm._v("Into Siemens login page click \"Don't remember your password?\".")]), _vm._v(" "), _c('li', [_vm._v("Follow the link from your E-mail.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8cfe374a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cfe374a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splash.vue
// module id = 491
// module chunks = 1